<template>
	<div>
		<van-row class="bmTitle">
			<van-col span="24">
				<h2>订单管理</h2>
			</van-col>
		</van-row>
		<van-row class="bmForm">
			<van-col span="24">
				<div v-if="orderList">
					<van-empty description="暂无订单信息" v-if="orderList.length == 0" />
					<van-card v-for="item in orderList" :key="item.id" style="padding:15px 16px;" v-else>
						<template #title>
							<h2 style="text-align: justify; font-size: 16px;margin:0;">订单编号:{{item.outTradeNo}}
							</h2>
						</template>
						<template #desc>
							<p style="font-size: 14px;">创建时间：{{item.crtTime}}</p>
							<p style="font-size: 14px;">参会人数：{{JSON.parse(item.payDetail).enteredList.length}}</p>
						</template>
						<template #price>
							<div style="margin-bottom:10px;">
								<span style="font-size: 16px;color:#d00;margin-right: 20px;">订单金额：¥{{item.money}}</span>

								<van-tag style="font-weight: normal; float: right;margin-top: 3px;" type="danger" round
									plain>{{item.payStatus == 0?'未支付':'已支付'}}</van-tag>
							</div>
							<div style="margin-bottom:10px;" v-if="item.refundMoney>0">
								<span style="font-size: 16px;color:#d00;margin-right: 20px;">退费金额：¥{{item.refundMoney}}</span>
							</div>
							<div style="margin-bottom:10px;" v-if="item.refundMoney>0">
								<span style="font-size: 16px;color:#d00;margin-right: 20px;">实付金额：¥{{item.actualMoney}}</span>
							</div>
						</template>
						<template #footer>
							<van-button type="danger" @click="viewUser(item)" color="#489bee" style="padding:0 10px;"
								size="mini">查看参会人</van-button>
							<van-button type="danger" @click="orderPay(item)" v-if="item.payStatus == 0" color="#eb5e5e"
								style="padding:0 10px;" size="mini">订单支付</van-button>
							<van-button type="danger" @click="cancelOrder(item)" v-if="item.payStatus == 0" color="#61ce89"
								style="padding:0 10px;" size="mini">取消订单</van-button>
								<!-- 跳过发票信息 2026-07-07 -->
							<!-- <van-button type="danger" @click="applyForInvoice(item)" v-if="item.payStatus == 1"
								color="#ebb340" style="padding:0 10px;" size="mini">{{item.orderInvoice?'发票信息':'申请发票'}}</van-button> -->
								<!-- 跳过发票信息 2026-07-07 end -->
							<!-- <van-button type="danger" @click="cancelInvoice(item)" v-if="item.payStatus == 1&&item.orderInvoice"
								color="#61ce89" style="padding:0 10px;" size="mini">取消发票</van-button> -->
						</template>
						
					</van-card>
					<div style="margin:0 0 0; position: fixed; bottom:0;left:0;width:92%;height:50px;background-color: #fff;padding:20px 4%;">
					  <van-button style="margin-top: 10px;" round block type="info" @click="fhsyb">返回首页</van-button>
					</div>
				</div>
			</van-col>
		</van-row>
		<van-dialog v-model="userShow" :show-confirm-button="false" theme="round-button" className="xfDialog">
			<template #title>
				<h4 style="margin:0 0 20px;font-size: 20px;">查看参会人</h4>
			</template>
			<div v-if="invoice" style="">
				<van-row class="bmForm" style="padding-top:0; position: relative;">
					<van-col span="24" style="height:300px;padding-bottom:50px;overflow-y: auto;">
						<van-cell-group>
							<van-cell v-for="(item,index) in enteredList" clickable :key="item.id">
								<template #title>
									{{item.name}} / {{item.phone}}
									<b style="float: right;color:#ee0a24;">￥{{item.bMf}}</b>
									<van-tag round plain type="danger" style="font-size: 14px;" v-if="item.refundStatus == 2">已退费</van-tag>
									<van-tag round plain type="warning" style="font-size: 14px;" v-if="item.transferStatus == 1">已转赠</van-tag>
									</h2>
								</template>
							</van-cell>
						</van-cell-group>
						<div style="margin:30px 16px 0; position:absolute;left:0;bottom:0;width:calc(100% - 32px)">
							<van-button round block type="info" @click="queren">确认</van-button>
						</div>
					</van-col>
				</van-row>
			</div>
		</van-dialog>
		<van-dialog v-model="fpShow" :show-confirm-button="false" theme="round-button" className="xfDialog">
			<template #title>
				<h4 style="margin:0 0 20px;font-size: 20px;">申请发票</h4>
			</template>
			<div v-if="invoice" style="">
				<van-row class="bmForm bmfpxxForm" style="padding-top:0; position: relative;">
					<van-col span="24" style="height:300px;padding-bottom:50px;overflow-y: auto;">
						<van-notice-bar style="font-size: 16px;" v-if="meeting.invoiceDeadline">
							温馨提示：发票申请截止至{{meeting.invoiceDeadline.split(' ')[0]}}，如有疑问请联系会议主办方。
							<template #left-icon>
								<van-icon name='info-o' size="20" style="margin-right: 10px;" />
							</template>
						</van-notice-bar>
						<van-form @submit="onSubmit">
							<div class="formInput hide"><van-field v-model="invoice.invoiceType" name="invoiceType"
									label="id" /></div>
							<div class="formInput">
								<van-field v-model="invoice.invoiceTitle" name="invoiceTitle" placeholder="请填写发票抬头"
									label="发票抬头" clearable required :rules="[{ required: true, message: '请填写发票抬头' }]" />
							</div>
							<div class="formInput">
								<van-field v-model="invoice.taxpayerIdentificationNumber"
									name="taxpayerIdentificationNumber" placeholder="请填写税务登记号" label="税务登记号" clearable
									required :rules="[{ required: true, message: '请填写税务登记号' }]" />
							</div>
							<div class="formInput">
								<van-field v-model="invoice.bankOfDeposit" name="bankOfDeposit" placeholder="请填写开户银行名称"
									label="开户银行名称" clearable />
							</div>
							<div class="formInput">
								<van-field v-model="invoice.accountOpening" name="accountOpening"
									placeholder="请填写基本开户账号" label="基本开户账号" clearable />
							</div>
							<div class="formInput">
								<van-field v-model="invoice.companyAddress" name="companyAddress"
									placeholder="请填写注册场所地址" label="注册场所地址" clearable />
							</div>
							<div class="formInput">
								<van-field v-model="invoice.contactTelephoneCompany" name="contactTelephoneCompany"
									placeholder="请填写注册固定电话" label="注册固定电话" clearable />
							</div>
							<div class="formInput">
								<van-field v-model="invoice.recipientEmail" name="recipientEmail"
									placeholder="请输入发票收件人邮箱" label="发票收件人邮箱" clearable required
									:rules="[{ pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, required:true, message: '请输入正确发票收件人邮箱'}]" />
							</div>
							<div style="margin:30px 16px 0; position:absolute;left:0;bottom:0;width:calc(100% - 32px)">
								<van-button round block type="info" native-type="submit">保存</van-button>
							</div>
						</van-form>
					</van-col>
				</van-row>
			</div>
		</van-dialog>
	</div>
</template>
<script>
	import Global from '../Global/global.vue';
	import {
		areaList
	} from '@vant/area-data';
	export default {
		data() {
			return {
				orderList: [],
				enteredList: [],
				fpShow: false,
				invoice: {
					invoiceType: 1,
					invoiceTitle: '', //发票抬头
					taxpayerIdentificationNumber: '', //税务登记号
					bankOfDeposit: '', //开户银行名称
					accountOpening: '', //基本开户账号
					companyAddress: '', //注册场所地址
					contactTelephoneCompany: '', //注册固定电话
					recipientEmail: '', //发票收件人邮箱
					fpxxEndTime: ''
				},
				meeting:{},
				userShow: false
			};
		},
		created() {
			this.toEnteredCenter()
		},
		methods: {
			fhsyb(){
					  this.$router.push('/personal/index');
			},
			//查看参会人
			viewUser(item) {
				this.userShow = true;
				this.enteredList = [];
				this.orderList.forEach((key,index)=>{
					if(key.id == item.id){
						this.enteredList = JSON.parse(key.payDetail).enteredList;
					}
				})
			},
			queren(){
				this.userShow = false;
			},
			//订单支付
			orderPay(item) {
				console.log(item);
				this.$cookies.set('meetingName', item.commodityName);
				this.$cookies.set('meetingId', item.meetingId);
				this.$cookies.set('cookies_meeting_order_payMoney', item.money);
				this.$cookies.set('cookise_order_outTradeNo', item.outTradeNo);
				this.$router.push('/charge/pay');
			},
			//取消订单
			cancelOrder(item) {
				this.$dialog.confirm({
					// title: '取消申请发票',
					message: '确定取消订单？',
				}).then(() => {
					// on close
					const hyMeetingId = sessionStorage.getItem('meetingId');
					const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
					var data = {
						meetingId: hyMeetingId,
						orderId: item.id
					}
					this.axios.post('/api/appweb/team/cancelOrder', data, {
						headers: {
							Authorization: ` ${token}`
						}
					}).then((res) => {
						const data = res.data.data;
						if (res.data.status == 200) {
							this.$toast.success(res.data.message);
							this.toEnteredCenter()
						}
					})
				}).catch(() => {
					// on cancel
				})
			},
			//申请发票
			applyForInvoice(item) {
				console.log(item);
				// this.fpShow = true;
				// this.orderId = item.id;
				// if(item.orderInvoice){
				// 	this.invoice = JSON.parse(item.orderInvoice);
				// }
				this.$router.push('/personal/member/fp?orderId='+item.id)
			},
			onSubmit(values) {
				console.log(values);
				values.invoiceType = parseInt(this.invoice.invoiceType);
				values.orderId = this.orderId;
				const hyMeetingId = sessionStorage.getItem('meetingId');
				const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
				this.axios.post('/api/appweb/orderDetails/applyOrderInvoice/' + hyMeetingId, values, {
					headers: {
						Authorization: ` ${token}`
					}
				}).then((res) => {
					const data = res.data;
					if (data.status == 200) {
						this.$dialog.alert({
							message: data.data,
						}).then(() => {
							// on close
							this.fpShow = false;
							this.toEnteredCenter();
							this.invoice = {
								invoiceType: 1,
								invoiceTitle: '', //发票抬头
								taxpayerIdentificationNumber: '', //税务登记号
								bankOfDeposit: '', //开户银行名称
								accountOpening: '', //基本开户账号
								companyAddress: '', //注册场所地址
								contactTelephoneCompany: '', //注册固定电话
								recipientEmail: '', //发票收件人邮箱
								fpxxEndTime: ''
							}
						});
					}else{
						this.$dialog.alert({
							message: data.message,
						}).then(() => {
							// on close
							this.fpShow = false;
							this.invoice = {
								invoiceType: 1,
								invoiceTitle: '', //发票抬头
								taxpayerIdentificationNumber: '', //税务登记号
								bankOfDeposit: '', //开户银行名称
								accountOpening: '', //基本开户账号
								companyAddress: '', //注册场所地址
								contactTelephoneCompany: '', //注册固定电话
								recipientEmail: '', //发票收件人邮箱
								fpxxEndTime: ''
							}
						});
					}
				})
			},
			//取消申请发票
			cancelInvoice(item) {
				this.$dialog.confirm({
					// title: '取消申请发票',
					message: '确定取消申请发票？',
				}).then(() => {
					// on close
					const hyMeetingId = sessionStorage.getItem('meetingId');
					const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
					var data = {
						"meetingId": hyMeetingId,
						"orderId": item.id
					}
					this.axios.post('api/appweb/orderDetails/cancelOrderInvoice/' + hyMeetingId, data, {
						headers: {
							Authorization: ` ${token}`
						}
					}).then((res) => {
						const data = res.data;
						if (data.status == 200) {
							this.$dialog.alert({
								message: data.data,
							}).then(() => {
								// on close
								this.toEnteredCenter();
							});
						}
					})
				}).catch(() => {
					// on cancel
				})
			},
			toEnteredCenter() {
				const hyMeetingId = sessionStorage.getItem('meetingId');
				const token = localStorage.getItem('sessionGrzxToken_' + hyMeetingId);
				if (!token) {
					this.$router.push('/personal/login?meetingId=' + hyMeetingId);
					return false;
				} else {
					this.axios.get('/api/appweb/entered/toEnteredCenter/' + hyMeetingId, {
						headers: {
							Authorization: ` ${token}`
						}
					}).then(res => {
						// console.log(res.data.data);
						if (res.data.status == 200) {
							if (res.data.data.meeting) {
								this.meeting = res.data.data.meeting;
								this.orderList = res.data.data.orderList;
							}
						}
					});
				}
			},
		},
		mounted() {

		}
	};
</script>

<style scoped="scoped">
	.bmForm {
		padding: 20px 0;
	}

	.bmTitle {
		padding: 0px 20px 10px;
		line-height: 40px;
		background: url(~@/assets/images/titlebg.png) no-repeat bottom center;
		background-size: 100% 100%;
		color: #fff;
		text-align: center;
	}

	.bmTitle h2 {
		font-weight: normal;
		font-size: 30px;
	}

	.formInput {
		padding: 4px 0;
		margin: 0 20px;
		border-bottom: 1px solid #e8e8e8;
	}

	.lineddd {
		height: 3px;
		background-color: #e8e8e8;
		margin-top: -1px;
	}

	.van-cell,
	.van-button {
		font-size: 16px;
	}

	.van-cell::after {
		border-bottom: 0;
	}

	.chmContent {
		position: relative;
		padding: 5px;
		width: 210px;
		margin: 20px auto 0;
	}

	.chmContent .chmewm {
		position: relative;
		padding: 4px;
		background: #fff;
		width: 202px;
	}

	.product-hover {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		-webkit-transition: opacity 0.3s ease;
		-moz-transition: opacity 0.3s ease;
		transition: opacity 0.3s ease;
		background-size: 30px 30px;
		background-image: -webkit-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		background-image: -moz-linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		background-image: linear-gradient(45deg, rgba(234, 176, 176, 1) 25%, transparent 25%, transparent 50%, rgba(234, 176, 176, 1) 50%, rgba(234, 176, 176, 1) 75%, transparent 75%, transparent);
		-webkit-animation: barberpole 0.5s linear infinite;
		-moz-animation: barberpole 0.5s linear infinite;
		animation: barberpole 0.5s linear infinite;
	}

	@-webkit-keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	@-moz-keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	@keyframes barberpole {
		from {
			background-position: 0 0;
		}

		to {
			background-position: 60px 30px;
		}
	}

	.hide {
		display: none;
	}
	.van-cell {
		padding: 20px 16px;
		border-bottom: 1px solid #e8e8e8;
	}
	.bmfpxxForm .van-cell {
		border-bottom: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/Personal/ordermanagement.vue